var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCalender(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Google_Calendar_icon_(2020) 1",
    clipPath: "url(#clip0_4508_13651)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M33.5791 10.421L23.1582 9.2631L10.4213 10.421L9.26318 22L10.421 33.579L22.0001 35.0264L33.5791 33.579L34.737 21.7107L33.5791 10.421Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M15.1713 28.3857C14.3058 27.801 13.7065 26.9471 13.3794 25.8181L15.3884 24.9902C15.5708 25.685 15.8892 26.2233 16.3437 26.6055C16.7953 26.9876 17.3453 27.1757 17.988 27.1757C18.6451 27.1757 19.2096 26.976 19.6813 26.5764C20.153 26.1769 20.3906 25.6674 20.3906 25.051C20.3906 24.42 20.1415 23.9045 19.6437 23.5052C19.1458 23.1059 18.5206 22.906 17.7737 22.906H16.613V20.9174H17.6549C18.2975 20.9174 18.8389 20.7438 19.2789 20.3964C19.7189 20.049 19.9389 19.5743 19.9389 18.9693C19.9389 18.4309 19.742 18.0024 19.3484 17.6812C18.9549 17.36 18.4568 17.1978 17.8518 17.1978C17.2613 17.1978 16.7923 17.3543 16.4449 17.6697C16.0975 17.9852 15.8456 18.3731 15.6865 18.8305L13.698 18.0026C13.9613 17.2557 14.4449 16.5957 15.1539 16.0255C15.8632 15.4552 16.7692 15.1686 17.8692 15.1686C18.6825 15.1686 19.4149 15.325 20.0634 15.6405C20.7118 15.9559 21.2213 16.3931 21.5889 16.9488C21.9565 17.5074 22.1389 18.1328 22.1389 18.8274C22.1389 19.5367 21.9682 20.1357 21.6265 20.6279C21.2849 21.12 20.8651 21.4962 20.3673 21.7598V21.8783C21.0244 22.1533 21.5599 22.5731 21.9825 23.1376C22.4023 23.7021 22.6135 24.3767 22.6135 25.164C22.6135 25.9514 22.4137 26.6548 22.0142 27.2714C21.6147 27.8881 21.0618 28.3743 20.3613 28.7274C19.658 29.0805 18.8677 29.26 17.9906 29.26C16.9746 29.2629 16.0368 28.9705 15.1713 28.3857Z",
    fill: "#1A73E8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M27.4998 18.4164L25.3055 20.0114L24.2026 18.3383L28.1598 15.484H29.6767V28.9474H27.4998V18.4164Z",
    fill: "#1A73E8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M33.5789 44L43.9999 33.579L38.7894 31.2633L33.5789 33.579L31.2632 38.7895L33.5789 44Z",
    fill: "#EA4335"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M8.10547 38.7895L10.4212 44H33.579V33.579H10.4212L8.10547 38.7895Z",
    fill: "#34A853"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M3.47358 0C1.55452 0 0 1.55452 0 3.47358V33.5788L5.21048 35.8945L10.421 33.5788V10.421H33.5788L35.8945 5.21048L33.579 0H3.47358Z",
    fill: "#4285F4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M0 33.579V40.5264C0 42.4457 1.55452 44 3.47358 44H10.421V33.579H0Z",
    fill: "#188038"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M33.5791 10.421V33.5788H44.0001V10.421L38.7896 8.10524L33.5791 10.421Z",
    fill: "#FBBC04"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M44.0001 10.421V3.47358C44.0001 1.5543 42.4455 0 40.5265 0H33.5791V10.421H44.0001Z",
    fill: "#1967D2"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4508_13651"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalender);
export default __webpack_public_path__ + "static/media/calender.e793071fe4c7d6700a2149c3a9c1cfec.svg";
export { ForwardRef as ReactComponent };